import React, { useEffect, useState } from "react";
import qs from "qs";
import axios from "axios";
import { FETCH_ALL_ARTICLES_FROM_STRAPI } from "../api/constants";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Pagination from "../components/Pagination/Pagination";

export default function AllNewsInsightsNew() {
  const [data, setData] = useState([]);
  const [heroData, setHeroData] = useState([]);

  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);

  const { pathname } = useLocation();

  const navigate = useNavigate();

  const fetchData = async (page = 1) => {
    const query = qs.stringify(
      {
        filters: {
          category: {
            slug: pathname.includes("blogs") ? "blog" : "news",
          },
        },
        sort: ["published_date:desc"],
        pagination: { page: page, pageSize: 25 },
        fields: ["published_date", "title", "slug"],
        populate: ["cover"],
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    );
    try {
      const res = await axios.get(`${FETCH_ALL_ARTICLES_FROM_STRAPI}?${query}`);
      setPageCount(res?.data?.meta?.pagination?.pageCount);
      setData(res?.data?.data);
      setHeroData(res?.data?.data[0]);
      if (res?.data?.data.length === 0) {
        navigate("/");
      }
    } catch (err) {
      console.log("Error Fetching Data");
      navigate("/");
    }
  };

  useEffect(() => {
    fetchData(page);
  }, [page, pathname, navigate]);

  return (
    <>
      {data?.length === 0 ? (
        <div className="flex items-center bg-black justify-center min-h-screen">
          <div className="w-12 h-12 border-4 border-white border-dashed rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="bg-black">
          <div className=" pt-28 lg:pt-48 xl:pt-48 lg:px-10  px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl xl:mx-auto 2xl:px-0 ">
            <h1 className="font-[optima-lt-pro] text-bhagwa font-normal uppercase text-lg xs:text-xl md:text-2xl 2xl:text-4xl">
              {pathname === "/blogs/"
                ? "Dubai Real Estate Blogs"
                : "Real Estate News and Insights"}
            </h1>
            <p className="font-[lato] text-white text-sm xs:text-base font-light text-justify">
              {pathname === "/blogs/"
                ? "Explore our blog for the latest industry trends and expert suggestions in real estate."
                : "Stay updated with the latest news and insights in the real estate market."}
            </p>

            {/*hero-img &text*/}
            <Link
              reloadDocument
              to={`${
                pathname.includes("blogs") ? "/blogs/" : "/real-estate-news/"
              }${heroData?.slug}/`}
              className="relative cursor-pointer group"
            >
              <img
                className=" w-full h-[500px] mt-6 sm:h-[400px] md:h-[400px] lg:h-[500px] object-cover group-hover:scale-105 transition-transform duration-300"
                src={
                  heroData?.cover?.formats?.large?.url || heroData?.cover?.url
                }
                alt={heroData?.cover?.alternativeText}
              />
              {/* Dark Overlay */}
              <div className="absolute w-full h-full inset-0 bg-black bg-opacity-40 group-hover:scale-105 transition-transform duration-300" />

              <div className="absolute flex flex-col inset-0 w-full h-full justify-end gap-2 px-6 md:pr-12 pb-12  text-white group-hover:scale-105 transition-transform duration-300">
                <h2 className="font-[optima-lt-pro]  uppercase w-[100%] text-base font-normal md:text-xl lg:w-[60%] xl:text-2xl line-clamp-2">
                  {heroData?.title}
                </h2>
                <span className="font-[lato] text-sm font-light">
                  {new Date(heroData?.published_date).toLocaleDateString()}
                </span>
              </div>
            </Link>

            {/*Blog Page Cards*/}
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 md:gap-4">
              {data?.slice(1, data?.length)?.map((item, index) => {
                return (
                  <Link
                    reloadDocument
                    to={`${
                      pathname.includes("blogs")
                        ? "/blogs/"
                        : "/real-estate-news/"
                    }${item?.slug}/`}
                    key={index}
                    className="mt-10 flex flex-col gap-4  cursor-pointer sm:h-[400px] md:h-[300px] lg:h-[400px] xl:h-[500px]"
                  >
                    <img
                      className="w-fit h-fit object-cover sm:h-[70%] sm:w-[100%]"
                      src={item?.cover?.formats?.large?.url || item?.cover?.url}
                      alt={item?.cover?.alternativeText}
                    />
                    <div className="flex flex-col gap-2">
                      <span className="text-xs font-[lato] font-light text-bhagwa text-grey-600 lg:text-sm">
                        {new Date(item?.published_date).toLocaleDateString()}
                      </span>
                      <span className="text-base text-white uppercase font-[optima-lt-pro] md:font-light xl:text-xl line-clamp-2">
                        {item?.title}
                      </span>
                    </div>
                  </Link>
                );
              })}
            </div>

            {/* Pagination */}
            <div className="py-4">
              <Pagination
                page={page}
                pageCount={pageCount}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
